export default __webpack_public_path__ + "static/media/blender-download.7c8ce6fb.png";